import { useCallback } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { isDevAuthBypass } from './oktaConfig';

type IdTokenClaims = {
  readonly email?: string;
  readonly name?: string;
  readonly preferred_username?: string;
};

const noopSignOut = () => {};

export function useAuthUser() {
  if (isDevAuthBypass) {
    return { isAuthenticated: false, email: undefined, name: undefined, signOut: noopSignOut };
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- isDevAuthBypass is a build-time constant
  const { oktaAuth, authState } = useOktaAuth();
  const isAuthenticated = Boolean(authState?.isAuthenticated);
  const claims = (authState?.idToken?.claims ?? undefined) as IdTokenClaims | undefined;
  const email = claims?.email ?? claims?.preferred_username;
  const name = claims?.name;

  // eslint-disable-next-line react-hooks/rules-of-hooks -- isDevAuthBypass is a build-time constant
  const signOut = useCallback(() => {
    void oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });
  }, [oktaAuth]);

  return { isAuthenticated, email, name, signOut };
}
